export default "__VITE_ASSET__yKzrrrs8__"